'use strict';

var scrollAnimate = require('base:components/scrollAnimate');

/**
 * Display the returned message.
 * @param {string} data - data returned from the server's ajax call
 * @param {Object} button - button that was clicked for contact us sign-up
 */
function displayMessage(data, button) {
    $.spinner().stop();
    var status;
    if (data.success) {
        status = 'alert-success';
    } else {
        status = 'alert-danger';
    }

    if ($('.contact-us-signup-message').length === 0) {
        $('body').append(
            '<div class="contact-us-signup-message"></div>'
        );
    }
    $('.contact-us-signup-message')
        .append('<div class="contact-us-signup-alert text-center ' + status + '" role="alert">' + data.msg + '</div>');

    setTimeout(function () {
        $('.contact-us-signup-message').remove();
        button.removeAttr('disabled');
    }, 3000);
}

module.exports = {
    validateField: function () {
        $('form .required.contact-us-b2b-mandatory input').on('keyup', function (e) {
            if ($(this).is(':visible') && e.keyCode !== 9) { // escape tab key
                if ($(this).val().length === 0) {
                    this.setCustomValidity('invalid');
                    $(this).addClass('is-invalid');
                    $(this).parents('.form-group').find('.invalid-feedback').text($(this).data('missing-error'));
                } else {
                    $(this).removeClass('is-invalid');
                    $(this).parent('.input-group').parent().find('.invalid-feedback')
                        .empty();
                }
            } else {
                $(this).removeClass('is-invalid');
                $(this).parent('.input-group').parent().find('.invalid-feedback')
                    .empty();
            }
        });
    
        $('form .required.contact-us-b2b-mandatory input').on('blur', function (e) {
            if ($(this).is(':visible')) {
                if ($(this).val().length === 0) {
                    this.setCustomValidity('invalid');
                    $(this).addClass('is-invalid');
                    $(this).parents('.form-group').find('.invalid-feedback').text($(this).data('missing-error'));
                } else {
                    $(this).removeClass('is-invalid');
                    $(this).parent('.input-group').parent().find('.invalid-feedback')
                        .empty();
                }
            } else {
                $(this).removeClass('is-invalid');
                $(this).parent('.input-group').parent().find('.invalid-feedback')
                    .empty();
            }
        });
    },
    subscribeContact: function () {
        $('textarea').keyup(function () {
            var $errorDiv = $(this).next('.invalid-feedback');
            if ($(this).val().length <= 0) {
                $(this).addClass('is-invalid');
                $errorDiv.show();
            } else {
                $errorDiv.hide();
                $(this).removeClass('is-invalid');
            }
        });

        $('#dwfrm_contactUs_file, #dwfrm_proCommunity_file').on('change', function (e) {
            var files = e.currentTarget.files;
            var approved = false;
            for (var x in files) {
                var filesize = ((files[x].size / 1024) / 1024).toFixed(4); // MB
                var filename = files[x].name;
                if (typeof filename !== 'undefined') {
                    var fileExtension = filename.substr(filename.lastIndexOf('.') + 1);
                    var autorizedExtension = ['gif', 'heic', 'jpg', 'jpeg', 'png', 'doc', 'docx', 'pdf'];
                    if (files[x].name != 'item' && typeof filename !== 'undefined' && filesize <= 10 && (autorizedExtension.indexOf(fileExtension) > -1)) {
                        approved = true;
                    }
                }
            }
            if (!approved) {
                $(this).val('');
                $(this).next().next().html($(this).attr('data-format-error'))
                    .show();
            } else {
                $(this).next().next().html('')
                    .hide();
            }
        });

        $('form button[type="submit"], form input[type="submit"]').on('click', function () {
            var isValid = true;
            $('form .required.contact-us-b2b-mandatory input').each(function (item) {
                if ($(this).is(':visible') && $(this).val().length === 0) {
                    $(this).addClass('is-invalid');
                    $(this).parents('.form-group').find('.invalid-feedback').text($(this).data('missing-error'));
                    if (isValid) {
                        scrollAnimate($('.contact-us'));
                    }
                    isValid = false;
                } else {
                    $(this).removeClass('is-invalid');
                    $(this).parent('.input-group').parent().find('.invalid-feedback')
                        .empty();
                }
            });
        });

        $('form.contact-us').submit(function (e) {
            var isValid = true;
            $('form .required.contact-us-b2b-mandatory input').each(function (item) {
                if ($(this).is(':visible') && $(this).val().length === 0) {
                    $(this).addClass('is-invalid');
                    $(this).parents('.form-group').find('.invalid-feedback').text($(this).data('missing-error'));
                    isValid = false;
                } else {
                    $(this).removeClass('is-invalid');
                    $(this).parent('.input-group').parent().find('.invalid-feedback')
                        .empty();
                }
            });
            if (!isValid) {
                e.preventDefault();
                return;
            }
            e.preventDefault();
            var form = $(this);
            $.spinner().start();
            if (grecaptcha) {
                grecaptcha.ready(function () {
                    grecaptcha.execute(window.app.preferences.reCaptchaSiteKey, { action: 'submit' }).then(function (token) {
                        form.append("<input type='hidden' name='dwfrm_contactUs_reCaptchaToken' value='" + token + "'/>");
                        var data = new FormData(form[0]);
                        var button = $('.subscribe-contact-us');
                        var url = form.attr('action');
                        button.attr('disabled', true);
                        $.ajax({
                            url: url,
                            type: 'post',
                            enctype: 'multipart/form-data',
                            dataType: 'json',
                            data: data,
                            processData: false,
                            contentType: false,
                            cache: false,
                            timeout: 60000,
                            success: function (data) {
                                if (data.success) {
                                    $('.contact-us').trigger('reset');
                                }
                                if (data.redirectUrl) {
                                    window.location.href = data.redirectUrl;
                                } else {
                                    displayMessage(data, button);
                                }
                                $.spinner().stop();
                            },
                            error: function (err) {
                                console.log(err);
                                displayMessage(err, button);
                                $.spinner().start();
                            }
                        });
                    });
                });
            }
        });
    },

    displayOrderNumber: function () {
        $('select.contact-topic').change(function () {
            $(this).find('option:selected').attr('data-showordernumber') == 'true' ? $('#order-number').show() : $('#order-number').hide();
            var selectedEmail = $(this).find('option:selected').attr('data-emailto');
            $('input.email-receive').val(selectedEmail);
        });
    },

    displaySecondLevelQuestion: function () {
        $('select.contact-topic').change(function () {
            var subQuestionID = $(this).find('option:selected').attr('sub-question-id');
            $('.contact-sub-topic-select').removeClass('required');
            $('.contact-sub-topic-select').addClass('d-none');
            var id = '#' + subQuestionID;
            $(id).addClass('required');
            $(id).removeClass('d-none');
        });
    },

    selectedSubQuestion: function () {
        $('select.contact-topic').change(function () {
            $.each($('.contact-sub-topic-select'), function () {
                if ($(this).is(':visible')) {
                    var selectedOption = $(this).find('option:selected').val();
                    $('#dwfrm_contactUs_selectedSubQuestion').val(selectedOption);
                }
            });

            var selectedTopic = $(this).find('option:selected').val();

            if (selectedTopic === 'Other') {
                $('#dwfrm_contactUs_selectedSubQuestion').val('');
            }
        });

        $('select.sub-topic-select').change(function () {
            var selectedOption = $(this).find('option:selected').val();
            $('#dwfrm_contactUs_selectedSubQuestion').val(selectedOption);
        });
    },

    radioDisplayForm: function () {
        if ($('input:radio[name="dwfrm_contactUs_personalOrPro"]').is(':checked') && $('input:radio[name="dwfrm_contactUs_personalOrPro"]:checked').val() === 'personal') {
            $('.contact-us-b2b').addClass('d-none');
            $('.contact-us-requestcountry-b2b').addClass('d-none');
            $('.contact-us-company-b2b').addClass('d-none');
            $('.b2b-account-radio').addClass('d-none');
            $('.contact-us-b2c').removeClass('d-none');
        } else if ($('input:radio[name="dwfrm_contactUs_hasB2BAccount"]:checked').val() === 'Yes') {
            $('.contact-us-b2b').removeClass('d-none');
            $('.b2b-account-radio').removeClass('d-none');
            $('.contact-us-b2c').addClass('d-none');
        } else {
            $('.contact-us-b2b').addClass('d-none');
            $('.contact-us-requestcountry-b2b').removeClass('d-none');
            $('.contact-us-company-b2b').removeClass('d-none');
            $('.b2b-account-radio').removeClass('d-none');
            $('.contact-us-b2c').removeClass('d-none');
        }

        $('input:radio[name="dwfrm_contactUs_personalOrPro"]').change(function () {
            if ($(this).is(':checked') && $(this).val() === 'personal') {
                $('.contact-us-b2b').addClass('d-none');
                $('.contact-us-requestcountry-b2b').addClass('d-none');
                $('.contact-us-company-b2b').addClass('d-none');
                $('.b2b-account-radio').addClass('d-none');
                $('.contact-us-b2c').removeClass('d-none');
            } else if ($('input:radio[name="dwfrm_contactUs_hasB2BAccount"]:checked').val() === 'Yes') {
                $('.contact-us-b2b').removeClass('d-none');
                $('.b2b-account-radio').removeClass('d-none');
                $('.contact-us-b2c').addClass('d-none');
            } else {
                $('.contact-us-b2b').addClass('d-none');
                $('.contact-us-requestcountry-b2b').removeClass('d-none');
                $('.contact-us-company-b2b').removeClass('d-none');
                $('.b2b-account-radio').removeClass('d-none');
                $('.contact-us-b2c').removeClass('d-none');
            }
        });

        $('input:radio[name="dwfrm_contactUs_hasB2BAccount"]').change(function () {
            if ($(this).is(':checked') && $(this).val() === 'Yes') {
                $(this).prop('checked', true);
                $('.contact-us-b2b').removeClass('d-none');
                $('.contact-us-b2c').addClass('d-none');
            } else {
                $(this).prop('checked', true);
                $('.contact-us-b2b').addClass('d-none');
                $('.contact-us-b2c').removeClass('d-none');
            }
        });
    },

    hideLoggedInContent: function () {
        if ($('.contact-us-landing-page').attr('data-user-logged-in') !== 'true') {
            $('.logged-in-section').remove();
        }
    }
};
